import { Box, Stack, ToggleButton, ToggleButtonGroup, Grid } from '@mui/material'
import { Code, BugReport } from '@mui/icons-material'
import MappingView from '../mapping/MappingView'
import TestingView from '../testing/TestingView'
import MappingPreview from './MappingPreview'
import { useTranslationMapDetailsContext } from '../../contexts/TranslationMapDetailsContext'
import { memo } from 'react'

export interface MappingDetailsProps {}

type ViewType = 'mapping' | 'testing'

const MappingDetails = memo(function MappingDetails(_props: MappingDetailsProps) {
  const { translationMap, mappingDetails } = useTranslationMapDetailsContext()

  const { currentView, setCurrentView } = mappingDetails

  // Early return if context values are not available
  if (!translationMap) {
    return <div>Loading...</div>
  }

  const handleViewChange = (event: React.MouseEvent<HTMLElement>, newView: ViewType | null) => {
    if (newView !== null) {
      setCurrentView(newView)
    }
  }

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <ToggleButtonGroup
          value={currentView}
          exclusive
          onChange={handleViewChange}
          aria-label="view selection"
          size="small"
          sx={{ '& .MuiToggleButton-root': { py: 0.5, px: 1.5 } }}
        >
          <ToggleButton value="mapping" aria-label="mapping view">
            <Code sx={{ mr: 0.5, fontSize: '1rem' }} />
            Mapping
          </ToggleButton>
          <ToggleButton value="testing" aria-label="testing view">
            <BugReport sx={{ mr: 0.5, fontSize: '1rem' }} />
            Testing
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Render Current View */}
      {currentView === 'mapping' && (
        <Grid container spacing={0} sx={{ height: '100%', paddingBottom: 2 }}>
          {/* First Column - Mapping View */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <MappingView />
          </Grid>

          {/* Second Column - Preview */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }} pl={2}>
            <MappingPreview isEnabled={!!translationMap.encoded_implementation} />
          </Grid>
        </Grid>
      )}
      {currentView === 'testing' && <TestingView />}
    </Stack>
  )
})

export default MappingDetails
